module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("page_0060_redirect")]) : _vm._e(), _vm._v(" "), _c('app-header', {
    attrs: {
      "no_menu": "true"
    }
  }, [_vm._v("esma")]), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('title-and-slot', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "title": _vm.messsage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "10px"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f0aab75","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/page_0060_redirect.vue
// module id = 958
// module chunks = 0